import React, { Fragment, useEffect, useState, useRef } from 'react';
import { HeaderListComponent, PageListComponent, FormWrapperInputComponent } from 'containers/backend/common/component/Index';
import DEFINE from 'constants/Define';
import { Link } from 'react-router-dom';
import * as Func from '../../../../../helpers/functions';
import WhitelistIpListing from './components/WhitelistIpListing';
import { useGetWhitelist } from 'hooks/appUI/useGetWhitelist';
import { Select, Modal, Input as AntInput } from "antd";
import { message } from 'antd';

const WhitelistIp = (props) => {
  const { hotels } = props.hotelState;
  const { match, t, appUIState } = props;
  const permissionActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.APP);

  const [query, setQuery] = useState({
    pageIndex: 1,
    pageSize: 10,
    OrderByDesc: true,
  });
  const {data: listAppUI, isLoading, error, paging, reLoadData} = useGetWhitelist(query);
  //! Function
  const onChangeTable = (pagination, filters, sorter) => {
      let newFilters = Func.genaratePaginateFilterSort(pagination, filters, sorter);
      setQuery(newFilters);
  }
  //!Effect
  useEffect(() => {
      if(appUIState.isReloadData){
          reLoadData && reLoadData();
      }
  },[appUIState.isReloadData])
  //!Render

  const ipAddressRef = useRef();
  const nameRef = useRef();
  const propertyRef = useRef();
  const urlRef = useRef();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = () => {
    if (permissionActions && permissionActions.allowCreateIp) {
      clearWhitelistIpPopupData();
      setIsModalOpen(true);
    }
  };
  const clearWhitelistIpPopupData = () => {
    const ipAddress = ipAddressRef.current?.state.value || "";
    const name = nameRef.current?.state.value || "";
    const property = propertyRef.current?.rcSelect.state.value || "";
    const url = urlRef.current?.state.value || "";
    if(ipAddress) {
      ipAddressRef.current.state.value = "";
    }
    if(name) {
      nameRef.current.state.value = "";
    }
    if(url) {
      urlRef.current.state.value = "";
    }
    if(property) {
      propertyRef.current.rcSelect.state.value = "";
    }
  }
  const handleOk = () => {
    if (permissionActions && permissionActions.allowCreateIp) {
      const ipAddress = ipAddressRef.current.state.value || "";
      const url = urlRef.current.state.value || "";
      let name = nameRef.current.state.value || "";
      if (name) {
        name = name.trim();
      }
      const property = propertyRef.current.rcSelect.state.value;

      if (!ipAddress) {
        message.error({
          content: t(`item.app.whitelistIpErrors.emptyIpAddress`),
          key: t(`item.app.whitelistIpErrors.emptyIpAddress`),
          duration: 2
        });
        return false;
      }

      if (!name) {
        message.error({
          content: t(`item.app.whitelistIpErrors.emptyName`),
          key: t(`item.app.whitelistIpErrors.emptyName`),
          duration: 2
        });
        return false;
      }

      if (!url) {
        message.error({
          content: t(`item.app.whitelistIpErrors.emptyUrl`),
          key: t(`item.app.whitelistIpErrors.emptyUrl`),
          duration: 2
        });
        return false;
      }

      if (!property || property === "" || property[0] === "") {
        message.error({
          content: t(`item.app.whitelistIpErrors.emptyProp`),
          key: t(`item.app.whitelistIpErrors.emptyProp`),
          duration: 2
        });
        return false;
      }

      const data = {
        "IP": ipAddress,
        "Name": name,
        "Url": url,
        "PropertyName": property[0].split("::")[0],
        "PropertyId": property[0].split("::")[1],
      };
      props.createWhitelistIp(data);
      // setIsModalOpen(false);
      // clearWhitelistIpPopupData();
    }
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const handleChange = (value) => {
  };
  const Option = Select.Option;

  useEffect(() => {
    props.getListHotels([]);
  }, []);

  return (
    <Fragment>
        <PageListComponent>
            <HeaderListComponent
                path={match.path}
                groupPath={'whitelistIp'}
                titleHeader={t('navigation.whitelistIp')}
                componentRight={
                    <Fragment>
                        {
                            permissionActions && permissionActions.allowCreateIp &&
                            <Link className='btn btn-primary' to="#" onClick={showModal}>{t('action.create')}</Link>
                        }
                    </Fragment>
                }
            />
            {permissionActions && permissionActions.allowViewWhitelistIp && (
              <WhitelistIpListing
                  isLoading={isLoading}
                  listAppUI={listAppUI}
                  paging={paging}
                  onChangeTable={onChangeTable}
                  t={t}
                  permissionActions={permissionActions}
                  deleteWhitelistIp={props.deleteWhitelistIp}
              />
            )}

        </PageListComponent>

        <Modal title="Tạo mới WhiteList IP" visible={isModalOpen} okText="Tạo mới" wrapClassName="create-ip" onOk={handleOk} onCancel={handleCancel}>
          <FormWrapperInputComponent
            isRequired={true}
            labelTitle={t(`item.app.whitelistIpAddress`)}
          >
            <AntInput placeholder={t(`item.app.whitelistIpAddress`)} ref={ipAddressRef} />
          </FormWrapperInputComponent>

          <FormWrapperInputComponent
            isRequired={true}
            labelTitle={t(`item.app.whitelistIpName`)}
          >
            <AntInput placeholder={t(`item.app.whitelistIpName`)} ref={nameRef} />
          </FormWrapperInputComponent>

          <FormWrapperInputComponent
            isRequired={true}
            labelTitle={t(`item.app.whitelistIpUrl`)}
          >
            <AntInput placeholder={t(`item.app.whitelistIpUrl`)} ref={urlRef} />
          </FormWrapperInputComponent>

          {hotels && (
            <FormWrapperInputComponent
              isRequired={true}
              labelTitle={t(`item.app.whitelistIpProperties`)}
            >
              <Select
                defaultValue=""
                style={{ width: "100%" }}
                onChange={handleChange}
                ref={propertyRef}
              >
                <Option value="">{t(`item.app.whitelistIpProperties`)}</Option>
                {hotels.map(item => item.isActive && (
                  <Option key={item.id} value={item.name + "::" + item.id} title={item.name}>{item.name}</Option>
                ))}
              </Select>
            </FormWrapperInputComponent>
          )}
        </Modal>

    </Fragment>
  );
}

export default WhitelistIp;
